<!-- 详情页 -->
<template>
  <div class="detail">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      中国律师网
    </div>
    <div class="detail-content" v-if="detailcontent && detailcontent.properties">
      <div class="detail-content-title" v-html="detailcontent.properties.title"></div>
      <div class="detail-content-date">
        <div>发表时间：{{ formatDate(detailcontent.$displays.publishedDate) }}</div>
        <div>作者：{{detailcontent.properties.author}}</div>
        <div>来源：{{detailcontent.properties.refUrl}}</div>
      </div>
      <div class="html-box" ref="richContentContainer" v-html="detailcontent.properties.content"></div>
    </div>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      entityId: "",
      from: "",
      detailcontent: {},
    };
  },
  created() {
    if (this.$route.params) {
      this.entityId = this.$route.params.entityId;
      this.from = this.$route.params.from;
      this.getDetail();
    }
  },
  watch: {
    detailcontent(newContent) {
      this.$nextTick(() => {
        // 更新DOM后，重新应用样式
        const container = this.$refs.richContentContainer;
        if (container) {
          container.innerHTML = newContent.properties.content;
          const images = container.querySelectorAll('img');
          images.forEach(img => {
            img.style.width = '100%';
            img.style.height = '100%';
            img.style['object-fit'] = 'contain';
          });
        }
      });
    }
  },
  methods: {
    formatDate(date) {
      return api.formatDate(date);
    },
    toIndex() {
      this.$router.push({
        name: this.from,
      });
    },
    getDetail() {
      let params = {
        entityId: this.entityId,
      };
      api.getDetail(params).then((res) => {
        if (res.data) {
          this.detailcontent = res.data;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .detail-content {
    margin: 1rem 0;
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 0.63rem 1rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    overflow: auto;
    .detail-content-title {
      padding: 0.88rem 0;
      font-weight: 600;
      font-size: 1.06rem;
      color: rgba(0,0,0,0.85);
      line-height: 1.31rem;
    }
    .detail-content-date {
      font-weight: 400;
      font-size: 0.75rem;
      color: rgba(0,0,0,0.45);
      line-height: 1.06rem;
    }
  }
}
</style>